// Optimize any customer-assets.emergentagent.com image URL through wsrv.nl —
// a free public image CDN that resizes and converts to WebP on-the-fly.
// Target: ≤150 KB per image on mobile, ≤350 KB on desktop.

const PROXY = "https://wsrv.nl/";

// Strip protocol so wsrv.nl recognizes it as an external URL
const clean = (src) => (src || "").replace(/^https?:\/\//, "");

// Default quality 55 — visually indistinguishable on photographs.
// il=1 = progressive/interlaced so images appear to load faster.
// we=1 = "without enlargement" so small originals aren't upscaled.
export const cdn = (src, w = 1100, quality = 55) =>
  `${PROXY}?url=${encodeURIComponent(clean(src))}&w=${w}&q=${quality}&output=webp&il=1&we=1`;

// Responsive srcSet — mobile / tablet / desktop.
export const srcSet = (src) =>
  `${cdn(src, 400)} 400w, ${cdn(src, 700)} 700w, ${cdn(src, 1100)} 1100w`;

// Hero images span the full viewport.
export const heroSrcSet = (src) =>
  `${cdn(src, 640)} 640w, ${cdn(src, 1080)} 1080w, ${cdn(src, 1440)} 1440w`;

// Thumbnails (gallery grid, masonry) — most aggressive compression.
export const thumb = (src, w = 400) => cdn(src, w, 48);
